// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content/TreatmentSelect/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New_PatientOptions_Existing_Content_TreatmentSelect_Content($patient_id: uuid!) {
  vaxiom_tx_cards(
    where: {
      patient: { _id: { _eq: $patient_id } }
      deleted: { _eq: false }
      txs: { deleted: { _eq: false } }
    }
    order_by: { latest_appointment_booking_start_time: desc_nulls_last }
  ) {
    _id
    name
    txs(where: { deleted: { _eq: false } }) {
      _id
      name
      status
      tx_status_name {
        id
        name
      }
    }
  }
}

`